import { render, staticRenderFns } from "./intention.vue?vue&type=template&id=d35c9372&scoped=true"
import script from "./intention.vue?vue&type=script&lang=js"
export * from "./intention.vue?vue&type=script&lang=js"
import style0 from "./intention.vue?vue&type=style&index=0&id=d35c9372&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d35c9372",
  null
  
)

export default component.exports